import NiceModal from '@ebay/nice-modal-react';

import MODALS from 'constants/modals';
import fetch from 'features/common/fetch';
import { resetErrorsByPage } from 'features/common/submitFormDialog/slice';
import { toIsoDateFormat } from 'utils/apiDateTime';
import { trimFormData } from 'utils/form';

import { NEW_CAMPAIGN_FORM_NAME } from './form';

export const saveNewCampaign =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const data = await getFormData(NEW_CAMPAIGN_FORM_NAME);
		const formData = trimFormData(data);

		const { channel, startDate, endDate, ...rest } = formData;
		const body = {
			...rest,
			channelId: Number(channel),
			startDate: toIsoDateFormat(startDate),
			endDate: toIsoDateFormat(endDate),
		};

		return dispatch(
			fetch.actions.post(fetch.constants.urls.campaign, {
				body,
				onSuccess: [
					() => () => {
						dispatch(resetErrorsByPage({ page: NEW_CAMPAIGN_FORM_NAME }));
						NiceModal.hide(MODALS.new_campaign);
					},
				],
			}),
		);
	};
